import React from 'react'
import { ConfirmButton } from '@/components/Button'
import { APITokenInfo } from '@/types'
import { Column, ColumnAction } from '@/components/Table'

export const apiTokenColumns: (
  callback: (action: ColumnAction, data: APITokenInfo) => () => void
) => Column<APITokenInfo & { action?: unknown }>[] = (callback) => [
  {
    id: 'name',
    label: '名称',
    width: 160,
    ellipsis: true,
  },
  {
    id: 'token',
    label: 'API Token',
  },
  {
    id: 'perms',
    label: '权限',
    width: 300,
    ellipsis: true,
  },
  {
    id: 'creator_mail',
    label: '创建者',
  },
  {
    id: 'expired_at',
    label: '过期时间',
  },
  {
    id: 'action',
    label: '操作',
    width: 120,
    format: ({ row }: { row: APITokenInfo; value: unknown }) => {
      return (
        <ConfirmButton danger="true" onClick={callback('delete', row)}>
          删除
        </ConfirmButton>
      )
    },
  },
]
